import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const validateInvitationApi = createAsyncThunk(
    'invitation/validate',
    async (token, { rejectWithValue }) => {
        try {
            const response = await fetch(
                `${ROOT_URL}/co-users/invitation/validate/${token}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            );
            const result = await response.json();
            return result;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

const initialState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    response: null,
    error: null,
};

const validateInvitationSlice = createSlice({
    name: 'validateInvitation',
    initialState,
    reducers: {
        resetValidationState: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
            state.response = null;
            state.error = null;
        },
    },
    extraReducers: {
        [validateInvitationApi.pending]: (state) => ({
            ...state,
            isLoading: true,
            error: null,
        }),
        [validateInvitationApi.fulfilled]: (state, action) => ({
            ...state,
            isLoading: false,
            isSuccess: true,
            isError: false,
            response: action.payload,
        }),
        [validateInvitationApi.rejected]: (state, action) => ({
            ...state,
            isLoading: false,
            isSuccess: false,
            isError: true,
            error: action.payload,
        }),
    },
});

export const { resetValidationState } = validateInvitationSlice.actions;
export default validateInvitationSlice;
